
import "./dashboardLayout.css"
import { useGlobalContext } from "../context/SocketContext";
import Header from "../pages/dashboard/Header";
import Sidebar from "../pages/dashboard/Sidebar";
import { Link } from "react-router-dom";
import { isDTS } from "../../utility/platform";
import { PhoneShellProvider, usePhoneShell, usePhoneViewport } from "../../context/PhoneShellContext";
import PhoneChrome from "../phone/PhoneChrome";

function DashboardLayout({ children }) {
    // Phone chrome is viewport-driven for guests and players. Auth only changes
    // what the top bar shows (Login/Sign up vs balance/account).
    const phoneWidth = usePhoneViewport();
    return (
        <PhoneShellProvider enabled={phoneWidth}>
            <DashboardFrame>{children}</DashboardFrame>
        </PhoneShellProvider>
    );
}

function DashboardFrame({ children }) {
    const { globalState } = useGlobalContext();
    const { enabled, searchOpen, entryOpen } = usePhoneShell();
    const shellClass = [
        "dashboardLayout dashboard_sec dashboard_sec_new",
        !globalState ? "dash_transition" : "",
        enabled ? "phone-shell" : "",
        enabled && searchOpen ? "phone-search-open" : "",
        enabled && entryOpen ? "phone-entry-open" : "",
    ].filter(Boolean).join(" ");

    return (
        <div className={shellClass}>
            <div className="container-fluid d-flex ps-0 pe-0">
                <div className={`left_side_sec ${globalState ? "sidebar_view" : "sidebar_hide"}`}>
                    <Sidebar />
                </div>
                <div className="right_side_sec">
                    <div className="">
                        <Header />
                    </div>
                    {enabled && <PhoneChrome />}
                    <div className="childrenWrapper">
                        {children}
                        {isDTS() && <footer className="dts-account-legal" aria-label="Legal links">
                            <Link to="/info/terms">Terms of Use</Link>
                            <Link to="/info/official-rules">Official Sweepstakes Rules</Link>
                            <Link to="/info/privacy">Privacy Policy</Link>
                            <Link to="/info/amoe">Free mail-in entry</Link>
                        </footer>}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DashboardLayout;
